import { Outlet } from "react-router-dom";
import { Header } from "@src/widgets/header";
import { LeftMenu } from "@src/widgets/LeftMenu";
import ErrorBoundary from "@src/shared/ui/ErrorBoundary/ErrorBoundary";
import wave from "@src/shared/assets/header copy 2.png";
import { CenterNotification } from "@src/shared/components/CenterNotification";

import styles from "./MainLayout.module.scss";

export const MainLayout = () => {
  return (
    <div className={styles.layout}>
      <LeftMenu />
      <div className={styles.contentArea}>
        <Header />
        <main className={styles.content}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
        <footer className={styles.footerWrapper}>
          <div className={styles.wrapperText}>
            <span className={styles.text}>© 2025 ООО «Цифра Лаб»</span>
          </div>
          <img src={wave} alt="wave" className={styles.wave} />
        </footer>
      </div>
      <CenterNotification />
    </div>
  );
};
